<template>
	<div class="card custom-card">
		<div class="card-header typo-h5 d-flex align-items-center">
			<span>EC Code</span>
			<CBadge
				color="alert"
				class="badge-ec-code-status"
				data-test-id="badge-ec-code-status"
			>
				Fail
			</CBadge>
			<CButton
				color="secondary"
				class="ml-auto"
				@click="$refs['modal-confirm-ec-code'].open()"
			>
				Retry Redeem EC-Code
			</CButton>
		</div>
		<div class="card-body">
			<CRow>
				<CCol>
					<h6>
						EC Code
					</h6>
					<div v-if="ecCode" class="order-meta">
						EC Code: <span class="order-meta-value">{{ ecCode }}</span>
					</div>
					<div v-if="university" class="order-meta">
						University: <span class="order-meta-value">{{ university }}</span>
					</div>
				</CCol>
			</CRow>
		</div>

		<ModalOrderDetailECCode
			ref="modal-confirm-ec-code"
			:is-submitting="edit.isUpdating || remark.isCreating"
			@onConfirm="handleMarkECCode"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ModalOrderDetailECCode from './ModalOrderDetailECCode.vue';

export default {
	name: 'OrderDetailECCode',
	components: {
		ModalOrderDetailECCode,
	},
	props: {
		orderId: {
			type: Number,
			default: 0,
		},
		ecCode: {
			type: String,
			default: '',
		},
		university: {
			type: String,
			default: '',
		},
	},
	computed: {
		...mapState('orders', {
			edit: 'edit',
			remark: 'remark',
		}),
		...mapGetters({
			username: 'auth/getUsername',
		}),
	},
	methods: {
		...mapActions({
			updateOrder: 'orders/updateOrder',
			createOrderRemark: 'orders/createOrderRemark',
		}),
		async handleMarkECCode(message) {
			if (!this.orderId) {
				return;
			}
			try {
				// Update remark, stamp EC Code
				const remarkTxt = `EC Code already redeemed by ${this.username}\n${message}`;
				await this.createOrderRemark({
					id: this.orderId,
					payload: { message: remarkTxt },
					forceReload: false,
				});

				const params = {
					mark_eccode_verified: true,
				};

				await this.updateOrder({ id: this.orderId, params });
			} catch {
				// do nothing
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.order-meta {
		@include typo-body-2;

		color: $color-black-45;

		// order-meta-value
		&-value {
			color: $color-black-90;
		}
	}

	.badge-ec-code-status {
		width: auto;
		padding: rem(7) rem(8);
		margin-left: rem(16);
		font-size: rem(14);
	}
</style>
